<template>
  <v-container fluid>
    <v-card color="transparent" flat>
      <v-row>
        <v-col cols="12">
          <div class="primary--text">
            Copyright ©2025 All Rights Reserved | Cinematic Celebration
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "AppFooter",
  components: {},
  methods: {},
};
</script>
